import React, { useRef, useState } from "react"
import styles from "./Sidebar.module.scss"
import WIP from "../Sessions/WIP/WIP"
import { UserInterface } from "../../App"

interface SidebarProps {
    setUser: any
    user: UserInterface
    newSession: any
}

const Sidebar: React.FC<SidebarProps> = ({ setUser, user, newSession }) => {
    const [showExpanded, setShowExpanded] = useState("")

    const SidebarButton: React.FC<{
        icon: string
        action: () => void
        notice?: boolean
        expandWith?: any
    }> = ({ icon, action, notice, expandWith }) => {
        const extensionRef = useRef<HTMLDivElement>(null)
        return (
            <>
                <div
                    onMouseOver={() => setShowExpanded(icon)}
                    onClick={() => {
                        extensionRef.current &&
                            extensionRef.current.classList.toggle(styles.expandListActive)
                        action()
                    }}
                    className={styles.button}>
                    {notice ? (
                        <div>
                            <i className="material-symbols-rounded">{icon}</i>
                            <div
                                style={{
                                    width: "1.3rem",
                                    height: "1.3rem",
                                    borderRadius: "100rem",
                                    backgroundColor: "tomato",
                                    margin: "-42px 0 0 2.5rem",
                                    position: "absolute",
                                    border: "2px solid white",
                                }}></div>
                        </div>
                    ) : (
                        <i className="material-symbols-rounded">{icon}</i>
                    )}
                </div>

                <div
                    ref={extensionRef}
                    style={{ marginTop: "-125px" }}
                    className={styles.expandList}>
                    <i
                        className="material-symbols-rounded"
                        style={{
                            transform: "rotate(90deg)",
                            fontSize: "4rem",
                            marginRight: "-1.8rem",
                            color: "#F4F5F6",
                        }}>
                        arrow_drop_down
                    </i>
                    <div className={styles.expandListPopup}>{expandWith}</div>
                </div>
            </>
        )
    }

    const SidebarItem: React.FC<{ name: string; icon: string; action: () => void }> = ({
        name,
        icon,
        action,
    }) => {
        return (
            <div
                id={icon === "folder" ? "sidebarFiles" : undefined}
                onClick={action}
                className={styles.item}>
                <i className="material-symbols-rounded">{icon}</i>
                <span
                    style={{
                        marginTop: "6px",
                        color: "black",
                        display: "block",
                    }}>
                    {name}
                </span>
            </div>
        )
    }

    return (
        <>
            <div className={styles.root}>
                <SidebarButton icon="domain" action={() => {}} />

                <div className={styles.segment}></div>
                <SidebarItem
                    name="Dashboard"
                    icon="dashboard"
                    action={() => {
                        newSession({ component: <WIP /> })
                    }}
                />
                <SidebarItem
                    name="Files"
                    icon="folder"
                    action={() => {
                        newSession({ view: "chat", send: "files" })
                    }}
                />
                <SidebarItem
                    name="Tasks"
                    icon="task"
                    action={() => {
                        newSession({ component: <WIP /> })
                    }}
                />
                <SidebarItem
                    name="Wikis"
                    icon="auto_stories"
                    action={() => {
                        newSession({ component: <WIP /> })
                    }}
                />

                <div className={styles.segment}></div>

                <SidebarButton icon="groups" action={() => {}} notice={false} expandWith={null} />
                <SidebarButton icon="group" action={() => {}} notice={false} expandWith={null} />
                <SidebarButton
                    icon="email"
                    action={() => {}}
                    expandWith={
                        <div className="Sidebar-module_selectChats_tW0XG">
                            <div className="Sidebar-module_heading_PRA0E">
                                <span className="Sidebar-module_title_EGoin">Org</span>
                            </div>
                            <br />
                            <br />
                            <div className="Sidebar-module_heading_PRA0E">
                                <span className="Sidebar-module_title_EGoin">Contacts</span>
                            </div>
                            <div className="Sidebar-module_item_1MeqW">Samuel Richards</div>
                            <div className="Sidebar-module_item_1MeqW">Patricia Zhang</div>
                            <div className="Sidebar-module_item_1MeqW">Ed Cunningham</div>
                            <div className="Sidebar-module_item_1MeqW">Bill Riker</div>
                            <div className="Sidebar-module_item_1MeqW">Cassandra Ryan</div>
                            <br />
                            <br />
                            <div className="Sidebar-module_heading_PRA0E">
                                <span className="Sidebar-module_title_EGoin">Groups</span>
                            </div>
                            <p className="Sidebar-module_item_1MeqW">Mom &amp; Dad</p>
                            <div className="Sidebar-module_heading_PRA0E">
                                <span className="Sidebar-module_title_EGoin">Updates</span>
                            </div>
                            <div className="Sidebar-module_item_1MeqW">OpenAI</div>
                            <div className="Sidebar-module_item_1MeqW">Microsoft Azure</div>
                            <div className="Sidebar-module_item_1MeqW">Amazon</div>
                            <div className="Sidebar-module_item_1MeqW">Heroku</div>
                            <div className="Sidebar-module_item_1MeqW">Spotify</div>
                            <div className="Sidebar-module_item_1MeqW">Heroku</div>
                            <div className="Sidebar-module_item_1MeqW">Quora</div>
                            <div className="Sidebar-module_item_1MeqW">Patreon</div>
                        </div>
                    }
                />

                <div className={styles.segment}></div>

                <SidebarButton
                    icon="more_horiz"
                    action={() => {}}
                    expandWith={
                        <div
                            style={{
                                display: "flex",
                                gap: "16px",
                                alignItems: "center",
                                padding: "1rem 1rem 0 1rem",
                            }}>
                            <SidebarItem
                                name="Notes"
                                icon="format_list_bulleted"
                                action={() => {
                                    newSession({ component: <WIP /> })
                                }}
                            />

                            <SidebarItem
                                name="App Store"
                                icon="apps"
                                action={() => {
                                    newSession({ component: <WIP /> })
                                }}
                            />

                            <SidebarItem
                                name="Calendar"
                                icon="calendar_month"
                                action={() => {
                                    newSession({ component: <WIP /> })
                                }}
                            />

                            <SidebarItem
                                name="Favs"
                                icon="bookmark"
                                action={() => {
                                    newSession({ component: <WIP /> })
                                }}
                            />
                        </div>
                    }
                />

                <div className={styles.profile}>{(user.name || "Guest").slice(0, 2)}</div>
                {user.name || "Guest"}
            </div>
        </>
    )
}

export default Sidebar
